import { ColumnDef } from "@tanstack/react-table";
import i18next from "i18next";

export const promsTableColumns: ColumnDef<any, string>[] = [
  {
    accessorKey: "name",
    header: () => i18next.t("patientPage_columns_name"),
    cell: (info) => info.renderValue(),
    size: 200,
    sortingFn: "text",
  },
  {
    accessorKey: "lastCompleted",
    header: () => i18next.t("patientPage_columns_last_completed"),
    cell: (info) => info.renderValue(),
    size: 100,
    sortingFn: (rowA, rowB) => {
      return rowB.original.lastCompletedDate - rowA.original.lastCompletedDate;
    },
  },
  {
    accessorKey: "timesCompletedDisplay",
    header: () => i18next.t("patientPage_columns_no_of_times_completed"),
    cell: (info) => info.renderValue(),
    enableSorting: false,
    size: 200,
  },
  {
    accessorKey: "lastTotalScore",
    header: () => i18next.t("patientPage_columns_last_total_score"),
    cell: (info) => info.renderValue(),
    size: 100,
    enableSorting: false,
  },
];
